<div class="w-full reschedule-job-dialog">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <div class="flex items-center flex-1 overflow-hidden">
            <h6 mat-dialog-title class="font-semibold primary-font w-full truncate" [title]="dialogTitle">{{'text.reschedule_job' | translate}} - {{dialogTitle}}</h6>
        </div>
        <div class="flex items-center mr-1 min-w-fit flex-0">
            <span mat-dialog-close
                class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
                <em class="ti ti-x text-xl font-bold"></em>
            </span>
        </div>
    </div>
    <div class="zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar">
        <div class="grid grid-cols-2 mb-2.5">
            <div class="col-span-1 text-base font-medium mb-1 text-gray-700">{{'text.scheduled_start_time' | translate}}</div>
            <div class="col-span-1 text-base font-medium mb-1 text-gray-700">{{'text.scheduled_end_time' | translate}}</div>
            <div class="col-span-1">{{startDateTime}}</div>
            <div class="col-span-1">{{endDateTime}}</div>
        </div>
        <div class="font-normal text-base text-red-600 my-3 cursor-default" [innerHtml]="formatedWarnings" *ngIf="!blockJobsOnHoliday">
        </div>
        <div class="flex items-center space-x-3 py-1" *ngIf="blockJobsOnHoliday">
            <i class="ti ti-alert-triangle text-red-500 text-3xl cursor-default"></i>
            <span class="text-red-500 font-medium text-base cursor-default">{{'dispatchBoard.scheduler.error.block_new_job_on_holiday' | translate}} : {{holidayName}}</span>
        </div>
        <div *ngIf="!blockJobsOnHoliday">
            <label for="reasonField"
                class="block text-base font-medium mb-2 text-gray-700 cursor-pointer">{{'reason.for.update.job.schedule'
                | translate}}</label>
            <textarea id="reasonField" name="reason"
                class="w-full max-h-52 min-h-32 overflow-y-auto zuper-scrollbar border border-gray-300 rounded-md p-3"
                [(ngModel)]="reason" cols="40">
          </textarea>
        </div>

    </div>

    <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
        <div class="flex justify-around space-x-4 bg-gray-50">
            <button type="button" mat-stroked-button mat-dialog-close
                class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                {{'cancel.text' | translate}}</button>
            <button [disabled]="updateInProgress || blockJobsOnHoliday"
                class="flex min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary"
                (click)="rescheduleJob()" [ngClass]="{'hover: cursor-not-allowed submitBtn opacity-30': blockJobsOnHoliday}">
                <mat-spinner [hidden]="!updateInProgress" class="mr-2"></mat-spinner>
                <span class="text-white">{{'update' | translate}}</span>
            </button>
        </div>
    </div>
</div>